import dayjs from 'dayjs';
import { date, number, object, string } from 'yup';

import { REQUIRED_FIELD } from '@/config/text.const';
import { GetBillingIntervalTypes } from '@/graphql/contracts/_generated_/getBillingIntervalTypes.query';
import { GetBillingTypes } from '@/graphql/contracts/_generated_/getBillingTypes.query';
import { SearchProducts } from '@/graphql/contracts/_generated_/searchProducts.query';
import { EnvUtils } from '@/utils/env.utils';

export const validationSchema = object().shape({
  stockCode: string()
    .transform((currentValue: SearchProducts['search'][number]) => {
      return currentValue?.stockCode || currentValue;
    })
    .typeError(REQUIRED_FIELD)
    .required(REQUIRED_FIELD),

  unitPrice: number()
    .typeError('Must be a number')
    .required(REQUIRED_FIELD),

  comments: string()
    .max(200, 'Must be maximum ${max} characters')
    .nullable(),

  billingStartDate: date()
    .test((value, context) => {
      const contractStartDate = context.options.context?.contract?.contractStartDate;

      if (!contractStartDate) {
        return context.createError({
          path: 'billingStartDate',
          message: 'Can\'t get "Contract Start Date"'
        });
      }

      if (value && !dayjs(value).isSameOrAfter(dayjs(contractStartDate), 'date')) {
        return context.createError({
          path: 'billingStartDate',
          message: 'Billing Start Date can\'t be less than Contract Start Date'
        });
      }

      return true;
    })
    .required(REQUIRED_FIELD)
    .nullable(),

  ...(!EnvUtils.isProRataFirstPeriodEnabled() ? {
    lineStartDate: date()
      .test((value, context) => {
        const contractStartDate = context.options.context?.contract?.contractStartDate;

        if (!contractStartDate) {
          return context.createError({
            path: 'lineStartDate',
            message: 'Can\'t get "Contract Start Date"'
          });
        }

        if (value && !dayjs(value).isSameOrAfter(dayjs(contractStartDate), 'date')) {
          return context.createError({
            path: 'lineStartDate',
            message: 'Line Start Date can\'t be less than Contract Start Date'
          });
        }

        return true;
      })
      .required(REQUIRED_FIELD)
      .nullable(),
  } : {}),

  billingType: string()
    .transform((currentValue: GetBillingTypes['billingTypes'][number]) => {
      return (currentValue && currentValue?.type)
        ? currentValue?.type
        : currentValue;
    })
    .required(REQUIRED_FIELD),

  billingInterval: string()
    .transform((currentValue: GetBillingIntervalTypes['billingIntervalTypes'][number]) => {
      return (currentValue && currentValue?.billingInterval)
        ? currentValue?.billingInterval
        : currentValue;
    })
    .required(REQUIRED_FIELD),
  shipToCustomer: object().shape({
    customerId: string()
      .nullable()
  }),
  invoiceToCustomer: object().shape({
    customerId: string()
      .nullable()
  }),
  unitType: string()
    .max(10, 'Must be maximum ${max} characters')
    .nullable(),
  poNumber: string()
    .nullable(),
});
